import BigWinMediator from "slotworks/mediators/big-win-mediator";
import State from "slotworks/state-machine/states/state";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Layers from "slotworks/graphics/layers/layers";
import Components from 'slotworks/components/components';
import AutoplayModel from "slotworks/model/autoplay-model";
import SmartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";

export default class BigWins extends State {

    private onComplete: Function;

    public onEnter(cascadeSkip: boolean) {
        if (!cascadeSkip) {
            const bigWinMediator = new BigWinMediator();

            this.onComplete = () => this.complete();

            const wasPromoVisible = Layers.PromoBetBar.container.visible;

            bigWinMediator.start().then((bigWin) => {
                if(wasPromoVisible && bigWin && CampaignsModel.isFreespinsActive()) {
                    Layers.PromoBetBar.show();
                    Layers.SmartButton.show();
                }
                bigWinMediator.end();
                if (this.onComplete) {
                    this.onComplete();

                }
            });
        }

        const freespins = CampaignsModel.freespins;
        if(freespins) {
            try {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            }catch(e) {

            }
        }
    }

    public onSkip(cascaded: boolean) {
        if (cascaded) {
            this.skip();
        } else {
            this.onComplete = () =>  this.skip();
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/big-wins.ts